import React from 'react'
import { Input } from 'reactstrap'
import { useMemo } from "react";
export const ColumnFilter = ({ column,placeholder }) => {
  const { filterValue, setFilter } = column
 
  return (
    <span>
      <Input
        type="text"
        value={filterValue || ''}
        placeholder={placeholder || "Search..."}
        onChange={e => setFilter(e.target.value)}
        style={{height:'25px',padding:'10px'}}
      />
    </span>
  )
}


// WEBPACK FOOTER //
// ./client/react/Admin/functions/ColumnFilter.js